import { connect } from "react-redux";
import AccountsIndex from "./AccountsIndex";
import { fetchAccounts } from "./actions/accounts";
import { fetchUsers } from "./actions/users";
import { fetchCostLimits } from "./actions/costLimits";
import queryString from "query-string";
import { prepareAccounts , ACCOUNTS_LIMIT } from "./helpers/accounts";


const mapStateToProps = (state, ownProps) => {
  const { entities } = state;
  const { location } = ownProps;
  const query = queryString.parse(location.search);

  const accounts = prepareAccounts(
    entities.accounts,
    entities.users,
    query,
    state.ui.sortAccounts
  );

  return {
    accounts,
    loading: state.ui.loadingAccounts,
    sortBy: state.ui.sortAccounts
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchAccounts: () => {
      dispatch(fetchAccounts({ limit: ACCOUNTS_LIMIT }));

      // there is no filter in the API to handle > or < roles
      // There is only ==, so we make 2 api calls :(
      const owners = {
        filters: {
          role: 1
        },
        limit: ACCOUNTS_LIMIT
      };
      dispatch(fetchUsers(owners));

      const superUsers = {
        filters: {
          role: 0
        },
        limit: ACCOUNTS_LIMIT
      };
      dispatch(fetchUsers(superUsers));
    },
    fetchCostLimits() {
      dispatch(fetchCostLimits());
    }
  };
};

const AccountsIndexContainer = connect(mapStateToProps, mapDispatchToProps)(
  AccountsIndex
);

export default AccountsIndexContainer;



// WEBPACK FOOTER //
// ./src/AccountsIndexContainer.js